module.exports = __webpack_public_path__ + "static/media/scienslogo.91ba03f0.png";